import {createClasses} from '@minimal/theme/create-classes';

// ----------------------------------------------------------------------

export const scrollbarClasses = {
  root: createClasses('scrollbar__root'),
};
